import { Component, Input } from '@angular/core';
import { Inventory } from '../../models/inventory.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../../services/inventory.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-inventory-modal',
  templateUrl: './inventory-modal.component.html',
  styleUrl: './inventory-modal.component.scss'
})
export class InventoryModalComponent {

  @Input() idBranch: string = '';
  @Input() inventory?: Inventory;

  public dataForm: DataFormModel = {
    description: {
      value: '',
      type: 'text',
      label: 'Descripción del inventario',
      requiredMessage: 'Por favor, ingresa la descripción',
      required: true,
      validators: [Validators.required]
    }
  };

  public formInventory!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public inventoryService: InventoryService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formInventory.controls;
  }

  async loadData() {
    this.loading = true;

    if (this.inventory) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.inventory) {
          const standardKey = key as keyof typeof this.inventory;
          this.dataForm[key].value = this.inventory[standardKey]!;
        }
      }
    }

    this.formInventory = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formInventory.invalid) {
      return;
    }

    if (this.inventory) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.inventoryService.create(
      this.idBranch,
      this.formInventory.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

  async update() {
    this.formInventory.value.idInventory = this.inventory!.idInventory;
    this.formInventory.value.idBranch = this.inventory!.idBranch;

    const flag = await this.inventoryService.update(
      this.formInventory.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

}
